<ng-template #expireModal let-modal>
  <div class="modal-header pb-0">
    <div class="modal-title header with-underline">
      Password about to expire
    </div>
    <button type="button"
        class="close"
        (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center mt-3">
    Your Active Directory account's password (used for Ahead Plus) will expire shortly in {{ days }} days.<br>
    If you don't change it before expiration, you will no longer be able to login.<br>
    <br>
    To change your password now, please use the following link ->
    <a href="javascript:void(0)" (click)="goToChangePassword()">Change your password</a>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-danger" (click)="modal.close()">OK</button>
  </div>
</ng-template>
